/* eslint-disable @typescript-eslint/no-require-imports*/

export const SUPPORTED_LOCALES = [
  { folder: "en-GB", loader: () => require("dayjs/locale/en-gb.js") },
  { folder: "en-US", loader: () => require("dayjs/locale/en.js") },
  { folder: "es-ES", loader: () => require("dayjs/locale/es.js") },
  { folder: "da-DK", loader: () => require("dayjs/locale/da.js") },
  { folder: "de-DE", loader: () => require("dayjs/locale/de.js") },
  { folder: "sv-SE", loader: () => require("dayjs/locale/sv.js") },
  { folder: "cs-CZ", loader: () => require("dayjs/locale/cs.js") },
  { folder: "pl-PL", loader: () => require("dayjs/locale/pl.js") },
  { folder: "fi-FI", loader: () => require("dayjs/locale/fi.js") },
  { folder: "it-IT", loader: () => require("dayjs/locale/it.js") },
  { folder: "pt-PT", loader: () => require("dayjs/locale/pt.js") },
] as const;

export type SupportedLocaleFolder = typeof SUPPORTED_LOCALES[number]["folder"];

/** Returns the translation lookup key for a locale folder.
 *  e.g. "da-DK" → "da", "en-GB" → "en-GB" */
export function toKey(folder: SupportedLocaleFolder): string {
  const lang = folder.split("-")[0];
  return lang === "en" ? folder : lang;
}
